/* ==========================================================================
   COURSE UNIT CATALOGUE
   --------------------------------------------------------------------------
   Individual course units — not degree programmes — for the universities the
   "take my class" pages target. Rendered as a filterable table by
   snippets/course-units-table.liquid.

   Codes for Chamberlain, Capella and Grand Canyon were taken from published
   curriculum grids and university transfer guides. The remainder use each
   school's documented course-code conventions.

   Catalogues change every term. Treat this as a strong starting point and
   verify against the linked official catalogue before relying on any single
   code in a sales conversation.

   Format: [code, title, department, level]
     level: UG = undergraduate, GR = graduate, DOC = doctoral
   ========================================================================== */
(function () {
  'use strict';

  window.TMOC_CATALOG = {

    chamberlain: {
      name: 'Chamberlain University',
      url: 'https://www.chamberlain.edu/academics/course-catalog',
      note: 'Codes below follow the published BSN curriculum grid. MSN and DNP specialty tracks add further NR-5xx and NR-7xx units.',
      courses: [
        ['NR-103', 'Transition to the Nursing Profession', 'Nursing', 'UG'],
        ['NR-222', 'Health and Wellness', 'Nursing', 'UG'],
        ['NR-224', 'Fundamentals — Skills', 'Nursing', 'UG'],
        ['NR-226', 'Fundamentals — Patient Care', 'Nursing', 'UG'],
        ['NR-228', 'Nutrition, Health and Wellness', 'Nursing', 'UG'],
        ['NR-283', 'Pathophysiology', 'Nursing', 'UG'],
        ['NR-293', 'Pharmacology for Nursing Practice', 'Nursing', 'UG'],
        ['NR-302', 'Health Assessment I', 'Nursing', 'UG'],
        ['NR-304', 'Health Assessment II', 'Nursing', 'UG'],
        ['NR-324', 'Adult Health I', 'Nursing', 'UG'],
        ['NR-325', 'Adult Health II', 'Nursing', 'UG'],
        ['NR-326', 'Mental Health Nursing', 'Nursing', 'UG'],
        ['NR-327', 'Maternal-Child Nursing', 'Nursing', 'UG'],
        ['NR-328', 'Pediatric Nursing', 'Nursing', 'UG'],
        ['NR-341', 'Complex Adult Health', 'Nursing', 'UG'],
        ['NR-360', 'Information Systems in Healthcare', 'Nursing', 'UG'],
        ['NR-446', 'Collaborative Healthcare', 'Nursing', 'UG'],
        ['NR-449', 'Evidence-Based Practice', 'Nursing', 'UG'],
        ['NR-451', 'RN Capstone Course', 'Nursing', 'UG'],
        ['NR-500', 'Foundational Concepts and Applications', 'Nursing (MSN)', 'GR'],
        ['NR-501', 'Theoretical Basis for Advanced Nursing Practice', 'Nursing (MSN)', 'GR'],
        ['NR-503', 'Population Health, Epidemiology and Statistical Principles', 'Nursing (MSN)', 'GR'],
        ['NR-505', 'Advanced Research Methods: Evidence-Based Practice', 'Nursing (MSN)', 'GR'],
        ['NR-506', 'Health Care Policy', 'Nursing (MSN)', 'GR'],
        ['NR-507', 'Advanced Pathophysiology', 'Nursing (MSN)', 'GR'],
        ['NR-508', 'Advanced Pharmacology', 'Nursing (MSN)', 'GR'],
        ['NR-509', 'Advanced Physical Assessment', 'Nursing (MSN)', 'GR'],
        ['NR-510', 'Leadership and Role of the APN', 'Nursing (MSN)', 'GR'],
        ['NR-599', 'Nursing Informatics Capstone', 'Nursing (MSN)', 'GR'],
        ['BIOS-251', 'Anatomy and Physiology I with Lab', 'Biological Sciences', 'UG'],
        ['BIOS-252', 'Anatomy and Physiology II with Lab', 'Biological Sciences', 'UG'],
        ['BIOS-255', 'Anatomy and Physiology III with Lab', 'Biological Sciences', 'UG'],
        ['BIOS-256', 'Anatomy and Physiology IV with Lab', 'Biological Sciences', 'UG'],
        ['BIOS-242', 'Fundamentals of Microbiology with Lab', 'Biological Sciences', 'UG'],
        ['CHEM-120', 'Introduction to General, Organic and Biological Chemistry', 'Chemistry', 'UG'],
        ['MATH-225', 'Statistical Reasoning for the Health Sciences', 'Mathematics', 'UG'],
        ['ENGL-147', 'Advanced English Composition', 'English', 'UG'],
        ['ENGL-148', 'Advanced English Composition', 'English', 'UG'],
        ['PHIL-347', 'Critical Reasoning', 'Philosophy', 'UG'],
        ['HUMN-303', 'Introduction to the Humanities', 'Humanities', 'UG'],
        ['SOCS-185', 'Culture and Society', 'Social Sciences', 'UG'],
        ['PSYC-110', 'Psychology', 'Psychology', 'UG'],
        ['UNIV-101', 'University Seminar', 'General Education', 'UG']
      ]
    },

    capella: {
      name: 'Capella University',
      url: 'https://capella.smartcatalogiq.com/',
      note: 'FlexPath and GuidedPath share course codes. NURS-FPX is nursing; NHS-FPX is health sciences; BUS-FPX is business.',
      courses: [
        ['NHS-FPX 4000', 'Developing a Health Care Perspective', 'Health Sciences', 'UG'],
        ['NURS-FPX 4000', 'Developing a Nursing Perspective', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4005', 'Nursing Leadership and Interprofessional Practice', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4010', 'Leading People, Processes and Organizations in Interprofessional Practice', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4015', 'Pathways to Patient Safety', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4020', 'Improving Quality of Care and Patient Safety', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4025', 'Research and Evidence-Based Decision Making', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4030', 'Making Evidence-Based Decisions', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4035', 'Enhancing Patient Outcomes and Quality of Care', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4040', 'Managing Health Information and Technology', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4045', 'Nursing Informatics in Health Care', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4050', 'Coordinating Patient-Centered Care', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4055', 'Optimizing Population Health through Community Practice', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4060', 'Practicing in the Community to Improve Population Health', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4065', 'Health Promotion, Quality and Safety', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 4900', 'Capstone Project for Nursing', 'Nursing (BSN)', 'UG'],
        ['NURS-FPX 5003', 'Health Assessment and Promotion for Disease Prevention', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 5004', 'Leadership and Group Collaboration', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 5005', 'Introduction to Nursing Research, Ethics and Technology', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 5006', 'Health Care Law and Policy', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 5007', 'Leading People, Processes and Organizations', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 6004', 'Health Care Law and Policy', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 6008', 'Economics and Decision Making in Health Care', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 6011', 'Evidence-Based Practice for Patient-Centered Care', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 6016', 'Quality Improvement of Interprofessional Care', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 6021', 'Biopsychosocial Concepts for Advanced Nursing Practice', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 6025', 'MSN Practicum', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 6026', 'Biopsychosocial Concepts for Advanced Nursing Practice 2', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 6030', 'MSN Practicum and Capstone', 'Nursing (MSN)', 'GR'],
        ['NURS-FPX 6103', 'The Nurse Educator Role', 'Nursing Education', 'GR'],
        ['NURS-FPX 6105', 'Teaching and Active Learning Strategies', 'Nursing Education', 'GR'],
        ['NURS-FPX 6107', 'Curriculum Design, Development and Evaluation', 'Nursing Education', 'GR'],
        ['NURS-FPX 6109', 'Integrating Technology into Nursing Education', 'Nursing Education', 'GR'],
        ['NURS-FPX 6111', 'Assessment and Evaluation in Nursing Education', 'Nursing Education', 'GR'],
        ['NURS-FPX 6210', 'Leadership and Management for Nurse Executives', 'Nursing Leadership', 'GR'],
        ['NURS-FPX 6212', 'Health Care Quality and Safety Management', 'Nursing Leadership', 'GR'],
        ['NURS-FPX 6214', 'Health Care Informatics and Technology', 'Nursing Leadership', 'GR'],
        ['NURS-FPX 6216', 'Advanced Finance and Operations Management', 'Nursing Leadership', 'GR'],
        ['NURS-FPX 6218', 'Leading the Future of Health Care', 'Nursing Leadership', 'GR'],
        ['NURS-FPX 6410', 'Fundamentals of Nursing Informatics', 'Nursing Informatics', 'GR'],
        ['NURS-FPX 6412', 'Analysis of Clinical Information Systems', 'Nursing Informatics', 'GR'],
        ['NURS-FPX 6414', 'Advancing Health Care through Data Mining', 'Nursing Informatics', 'GR'],
        ['NURS-FPX 6416', 'Managing the Nursing Informatics Life Cycle', 'Nursing Informatics', 'GR'],
        ['NHS-FPX 4000', 'Developing a Health Care Perspective', 'Health Sciences', 'UG'],
        ['NHS-FPX 5004', 'Leadership and Group Collaboration', 'Health Sciences', 'GR'],
        ['NHS-FPX 6008', 'Economics and Decision Making in Health Care', 'Health Sciences', 'GR'],
        ['BUS-FPX 3007', 'Organizational Communication', 'Business', 'UG'],
        ['BUS-FPX 3030', 'Marketing Foundations', 'Business', 'UG'],
        ['BUS-FPX 3040', 'Fundamentals of Human Resource Management', 'Business', 'UG'],
        ['BUS-FPX 4061', 'Managerial Accounting', 'Business', 'UG'],
        ['PSYC-FPX 3500', 'Learning and Cognition', 'Psychology', 'UG'],
        ['PSYC-FPX 4600', 'Research Methods in Psychology', 'Psychology', 'UG']
      ]
    },

    gcu: {
      name: 'Grand Canyon University',
      url: 'https://www.gcu.edu/degree-programs',
      note: 'The V / VN suffix marks the online delivery version of a course. Codes verified against GCU transfer guides.',
      courses: [
        ['NRS-410V', 'Pathophysiology and Nursing Management of Clients\u2019 Health', 'Nursing', 'UG'],
        ['NRS-427VN', 'Concepts in Community and Public Health', 'Nursing', 'UG'],
        ['NRS-428VN', 'Concepts in Community and Public Health', 'Nursing', 'UG'],
        ['NRS-429VN', 'Family-Centered Health Promotion', 'Nursing', 'UG'],
        ['NRS-430V', 'Professional Dynamics', 'Nursing', 'UG'],
        ['NRS-433V', 'Introduction to Nursing Research', 'Nursing', 'UG'],
        ['NRS-434VN', 'Health Assessment', 'Nursing', 'UG'],
        ['NRS-440VN', 'Trends and Issues in Health Care', 'Nursing', 'UG'],
        ['NRS-451VN', 'Nursing Leadership and Management', 'Nursing', 'UG'],
        ['NRS-490', 'Professional Capstone and Practicum', 'Nursing', 'UG'],
        ['NRS-493', 'Professional Capstone and Practicum', 'Nursing', 'UG'],
        ['HLT-362V', 'Applied Statistics for Health Care Professionals', 'Health Sciences', 'UG'],
        ['HLT-306V', 'Advanced Patient Care', 'Health Sciences', 'UG'],
        ['HLT-205V', 'Health Care Management', 'Health Sciences', 'UG'],
        ['PHI-413V', 'Ethical and Spiritual Decision Making in Health Care', 'Philosophy', 'UG'],
        ['PHI-105', 'Introduction to Critical Thinking', 'Philosophy', 'UG'],
        ['CWV-101', 'Christian Worldview', 'Theology', 'UG'],
        ['CWV-301', 'Christian Worldview', 'Theology', 'UG'],
        ['UNV-103', 'University Success', 'General Education', 'UG'],
        ['UNV-104', '21st Century Skills: Critical Thinking and Problem Solving', 'General Education', 'UG'],
        ['UNV-504', 'Introduction to Graduate Studies in the Health Sciences', 'General Education', 'GR'],
        ['MAT-144', 'College Mathematics', 'Mathematics', 'UG'],
        ['MAT-154', 'Applications of College Algebra', 'Mathematics', 'UG'],
        ['BIO-201', 'Human Anatomy and Physiology I', 'Biology', 'UG'],
        ['BIO-202', 'Human Anatomy and Physiology II', 'Biology', 'UG'],
        ['BIO-319', 'Applied Nutrition', 'Biology', 'UG'],
        ['ENG-105', 'English Composition I', 'English', 'UG'],
        ['ENG-106', 'English Composition II', 'English', 'UG'],
        ['PSY-102', 'General Psychology', 'Psychology', 'UG'],
        ['PSY-357', 'Lifespan Development Psychology', 'Psychology', 'UG'],
        ['SOC-100', 'Everyday Sociology', 'Sociology', 'UG'],
        ['ACC-370', 'Financial Accounting', 'Business', 'UG'],
        ['MGT-420', 'Organizational Behavior and Management', 'Business', 'UG'],
        ['MKT-315', 'Marketing Management', 'Business', 'UG'],
        ['NUR-513', 'Introduction to Advanced Registered Nursing', 'Nursing (MSN)', 'GR'],
        ['NUR-590', 'Evidence-Based Practice Project', 'Nursing (MSN)', 'GR'],
        ['NUR-621', 'Health Care Finance', 'Nursing (MSN)', 'GR'],
        ['NUR-641E', 'Advanced Pathophysiology and Pharmacology', 'Nursing (MSN)', 'GR']
      ]
    },

    wgu: {
      name: 'Western Governors University',
      url: 'https://www.wgu.edu/online-nursing-health-degrees.html',
      note: 'WGU measures progress in competency units (CUs) rather than credit hours, and assessments are either objective (OA) or performance (PA).',
      courses: [
        ['C121', 'Survey of United States History', 'General Education', 'UG'],
        ['C168', 'Critical Thinking and Logic', 'General Education', 'UG'],
        ['C455', 'English Composition I', 'General Education', 'UG'],
        ['C456', 'English Composition II', 'General Education', 'UG'],
        ['C458', 'Health, Fitness and Wellness', 'General Education', 'UG'],
        ['C464', 'Introduction to Communication', 'General Education', 'UG'],
        ['C475', 'Care of the Older Adult', 'Nursing', 'UG'],
        ['C304', 'Professional Roles and Values', 'Nursing', 'UG'],
        ['C155', 'Organizational Systems and Quality Leadership', 'Nursing', 'UG'],
        ['C158', 'Community Health and Population-Focused Nursing', 'Nursing', 'UG'],
        ['C361', 'Information Technology in Nursing Practice', 'Nursing', 'UG'],
        ['C787', 'Advanced Standing for RN License', 'Nursing', 'UG'],
        ['C820', 'Biochemistry', 'Science', 'UG'],
        ['C165', 'Integrated Physical Sciences', 'Science', 'UG'],
        ['C871', 'Anatomy and Physiology I', 'Science', 'UG'],
        ['C872', 'Anatomy and Physiology II', 'Science', 'UG'],
        ['C955', 'Applied Probability and Statistics', 'Mathematics', 'UG'],
        ['C957', 'Applied Algebra', 'Mathematics', 'UG'],
        ['C182', 'Introduction to IT', 'Information Technology', 'UG'],
        ['C844', 'Emerging Technologies in Cybersecurity', 'Information Technology', 'UG'],
        ['C846', 'Business of IT — Applications', 'Information Technology', 'UG'],
        ['C179', 'Business of IT — Applications', 'Information Technology', 'UG'],
        ['C170', 'Data Management — Foundations', 'Information Technology', 'UG'],
        ['C175', 'Data Management — Applications', 'Information Technology', 'UG'],
        ['C482', 'Software Engineering', 'Information Technology', 'UG'],
        ['C213', 'Accounting for Decision Makers', 'Business', 'UG'],
        ['C214', 'Financial Management', 'Business', 'UG'],
        ['C483', 'Principles of Management', 'Business', 'UG'],
        ['C716', 'Business Communication', 'Business', 'UG'],
        ['C720', 'Operations and Supply Chain Management', 'Business', 'UG'],
        ['C721', 'Change Management', 'Business', 'UG'],
        ['D024', 'Advanced Standing for the RN Licence', 'Nursing', 'UG'],
        ['D026', 'Anatomy and Physiology I', 'Science', 'UG'],
        ['D027', 'Anatomy and Physiology II', 'Science', 'UG'],
        ['D029', 'Microbiology with Lab', 'Science', 'UG'],
        ['D220', 'Information Technology in Nursing Practice', 'Nursing', 'UG'],
        ['D236', 'Pathophysiology', 'Nursing', 'UG'],
        ['D265', 'Critical Thinking: Reason and Evidence', 'General Education', 'UG'],
        ['D269', 'Essentials of Advanced Nursing Roles', 'Nursing (MSN)', 'GR'],
        ['D390', 'Fundamentals of Nursing Leadership', 'Nursing (MSN)', 'GR']
      ]
    },

    snhu: {
      name: 'Southern New Hampshire University',
      url: 'https://www.snhu.edu/online-degrees',
      note: 'SNHU runs 8-week online terms. Course numbering: 100/200 lower division, 300/400 upper division, 500/600 graduate.',
      courses: [
        ['ENG-122', 'English Composition I', 'English', 'UG'],
        ['ENG-123', 'English Composition II', 'English', 'UG'],
        ['ENG-190', 'Research and Presentation', 'English', 'UG'],
        ['IDS-100', 'Perspectives in Liberal Arts', 'Interdisciplinary Studies', 'UG'],
        ['IDS-105', 'Global Perspectives', 'Interdisciplinary Studies', 'UG'],
        ['IDS-403', 'Technology and Society', 'Interdisciplinary Studies', 'UG'],
        ['MAT-133', 'Introduction to Statistical Analysis', 'Mathematics', 'UG'],
        ['MAT-136', 'Applied Statistics I for STEM', 'Mathematics', 'UG'],
        ['MAT-240', 'Applied Statistics', 'Mathematics', 'UG'],
        ['MAT-243', 'Applied Statistics for STEM', 'Mathematics', 'UG'],
        ['ACC-201', 'Financial Accounting', 'Accounting', 'UG'],
        ['ACC-202', 'Managerial Accounting', 'Accounting', 'UG'],
        ['ACC-308', 'Intermediate Accounting II', 'Accounting', 'UG'],
        ['ACC-330', 'Federal Taxation I', 'Accounting', 'UG'],
        ['ACC-620', 'Financial Reporting I', 'Accounting', 'GR'],
        ['BUS-206', 'Business Law I', 'Business', 'UG'],
        ['BUS-210', 'Managing and Leading in Business', 'Business', 'UG'],
        ['BUS-225', 'Critical Business Skills for Success', 'Business', 'UG'],
        ['BUS-300', 'Ethical Decision Making', 'Business', 'UG'],
        ['BUS-330', 'Introduction to Marketing', 'Business', 'UG'],
        ['BUS-400', 'Corporate Governance', 'Business', 'UG'],
        ['MBA-560', 'Business Law', 'Business (MBA)', 'GR'],
        ['MBA-620', 'Financial Statement Analysis', 'Business (MBA)', 'GR'],
        ['FIN-320', 'Principles of Finance', 'Finance', 'UG'],
        ['FIN-330', 'Corporate Finance', 'Finance', 'UG'],
        ['MKT-205', 'Marketing Essentials', 'Marketing', 'UG'],
        ['MKT-310', 'Consumer Behavior', 'Marketing', 'UG'],
        ['ECO-201', 'Microeconomics', 'Economics', 'UG'],
        ['ECO-202', 'Macroeconomics', 'Economics', 'UG'],
        ['PSY-108', 'Introduction to Psychology', 'Psychology', 'UG'],
        ['PSY-215', 'Abnormal Psychology', 'Psychology', 'UG'],
        ['PSY-223', 'Research Methods in Psychology', 'Psychology', 'UG'],
        ['PSY-328', 'Human Growth and Development', 'Psychology', 'UG'],
        ['SCS-100', 'Perspectives in the Social Sciences', 'Social Sciences', 'UG'],
        ['SOC-112', 'Introduction to Sociology', 'Sociology', 'UG'],
        ['HIS-100', 'Perspectives in History', 'History', 'UG'],
        ['HIS-200', 'Applied History', 'History', 'UG'],
        ['CS-210', 'Programming Languages', 'Computer Science', 'UG'],
        ['CS-250', 'Software Development Lifecycle', 'Computer Science', 'UG'],
        ['CS-305', 'Software Security', 'Computer Science', 'UG'],
        ['CS-330', 'Computational Graphics and Visualization', 'Computer Science', 'UG'],
        ['CS-340', 'Client/Server Development', 'Computer Science', 'UG'],
        ['IT-140', 'Introduction to Scripting', 'Information Technology', 'UG'],
        ['IT-145', 'Foundation in Application Development', 'Information Technology', 'UG'],
        ['IT-201', 'Computer Platform Technologies', 'Information Technology', 'UG'],
        ['IT-212', 'Introduction to Computer Networks', 'Information Technology', 'UG'],
        ['NUR-300', 'Concepts in Nursing Practice', 'Nursing', 'UG'],
        ['NUR-320', 'Health Assessment', 'Nursing', 'UG'],
        ['NUR-440', 'Evidence-Based Practice', 'Nursing', 'UG'],
        ['HCM-345', 'Health Care Reimbursement', 'Health Care Management', 'UG'],
        ['HIM-500', 'Health Information Management', 'Health Information', 'GR']
      ]
    },

    walden: {
      name: 'Walden University',
      url: 'https://catalog.waldenu.edu/',
      note: 'Walden runs quarter-based online terms. NURS prefixes span BSN, MSN and DNP.',
      courses: [
        ['NURS-3000', 'Issues and Trends in Nursing', 'Nursing (BSN)', 'UG'],
        ['NURS-3005', 'The Context of Healthcare Delivery', 'Nursing (BSN)', 'UG'],
        ['NURS-3020', 'Health Assessment', 'Nursing (BSN)', 'UG'],
        ['NURS-3100', 'Issues and Trends in Nursing', 'Nursing (BSN)', 'UG'],
        ['NURS-3110', 'Information Management in Nursing and Healthcare', 'Nursing (BSN)', 'UG'],
        ['NURS-4000', 'Research and Scholarship for Evidence-Based Practice', 'Nursing (BSN)', 'UG'],
        ['NURS-4005', 'Topics in Clinical Nursing', 'Nursing (BSN)', 'UG'],
        ['NURS-4010', 'Family, Community and Population-Based Care', 'Nursing (BSN)', 'UG'],
        ['NURS-4015', 'Pathways to Safe, Quality Healthcare', 'Nursing (BSN)', 'UG'],
        ['NURS-4020', 'Leadership Competencies in Nursing and Healthcare', 'Nursing (BSN)', 'UG'],
        ['NURS-5000', 'Foundations of Graduate Study', 'Nursing (MSN)', 'GR'],
        ['NURS-6003', 'Foundations for Graduate Study', 'Nursing (MSN)', 'GR'],
        ['NURS-6050', 'Policy and Advocacy for Population Health', 'Nursing (MSN)', 'GR'],
        ['NURS-6051', 'Transforming Nursing and Healthcare through Technology', 'Nursing (MSN)', 'GR'],
        ['NURS-6052', 'Essentials of Evidence-Based Practice', 'Nursing (MSN)', 'GR'],
        ['NURS-6053', 'Interprofessional Organizational and Systems Leadership', 'Nursing (MSN)', 'GR'],
        ['NURS-6501', 'Advanced Pathophysiology', 'Nursing (MSN)', 'GR'],
        ['NURS-6512', 'Advanced Health Assessment and Diagnostic Reasoning', 'Nursing (MSN)', 'GR'],
        ['NURS-6521', 'Advanced Pharmacology', 'Nursing (MSN)', 'GR'],
        ['NURS-6531', 'Advanced Practice Care of Adults', 'Nursing (MSN)', 'GR'],
        ['NURS-6541', 'Primary Care of Adolescents and Children', 'Nursing (MSN)', 'GR'],
        ['NURS-6630', 'Psychopharmacologic Approaches to Mental Health', 'Nursing (MSN)', 'GR'],
        ['NURS-6640', 'Psychotherapy with Individuals', 'Nursing (MSN)', 'GR'],
        ['NURS-8000', 'Foundations for Doctoral Study', 'Nursing (DNP)', 'DOC'],
        ['NURS-8100', 'Healthcare Policy and Advocacy', 'Nursing (DNP)', 'DOC'],
        ['NURS-8200', 'Methods for Evidence-Based Practice', 'Nursing (DNP)', 'DOC'],
        ['NURS-8210', 'Transforming Nursing and Healthcare through Technology', 'Nursing (DNP)', 'DOC'],
        ['NURS-8302', 'Leading Change in Complex Systems', 'Nursing (DNP)', 'DOC'],
        ['PSYC-3001', 'Introduction to Psychology', 'Psychology', 'UG'],
        ['PSYC-6002', 'Foundations for Graduate Study in Psychology', 'Psychology', 'GR'],
        ['EDUC-6610', 'Teacher as Professional', 'Education', 'GR'],
        ['MMHA-6300', 'Healthcare Financial Management', 'Healthcare Administration', 'GR'],
        ['SOCW-6051', 'Diversity, Human Rights and Social Justice', 'Social Work', 'GR'],
        ['SOCW-6060', 'Social Work Theory and Clinical Practice', 'Social Work', 'GR'],
        ['RSCH-8110', 'Research Theory, Design and Methods', 'Research', 'DOC']
      ]
    },

    strayer: {
      name: 'Strayer University',
      url: 'https://www.strayer.edu/degrees',
      note: 'Strayer runs 11-week quarters. Numbering: 100\u2013200 introductory, 300\u2013400 upper division, 500+ graduate.',
      courses: [
        ['ENG-115', 'English Composition', 'English', 'UG'],
        ['ENG-215', 'Research and Writing', 'English', 'UG'],
        ['ENG-315', 'Professional Communications', 'English', 'UG'],
        ['MAT-105', 'Quantitative Reasoning', 'Mathematics', 'UG'],
        ['MAT-300', 'Statistics', 'Mathematics', 'UG'],
        ['ACC-100', 'Accounting I', 'Accounting', 'UG'],
        ['ACC-206', 'Accounting II', 'Accounting', 'UG'],
        ['ACC-304', 'Intermediate Accounting II', 'Accounting', 'UG'],
        ['ACC-317', 'Federal Taxation', 'Accounting', 'UG'],
        ['ACC-403', 'Auditing', 'Accounting', 'UG'],
        ['ACC-556', 'Financial Accounting for Managers', 'Accounting', 'GR'],
        ['BUS-100', 'Introduction to Business', 'Business', 'UG'],
        ['BUS-302', 'Management Concepts', 'Business', 'UG'],
        ['BUS-309', 'Business Ethics', 'Business', 'UG'],
        ['BUS-311', 'Business Law I', 'Business', 'UG'],
        ['BUS-320', 'Managerial Finance', 'Business', 'UG'],
        ['BUS-475', 'Business and Society', 'Business', 'UG'],
        ['BUS-499', 'Business Administration Capstone', 'Business', 'UG'],
        ['BUS-508', 'Contemporary Business', 'Business (MBA)', 'GR'],
        ['BUS-599', 'Strategic Management', 'Business (MBA)', 'GR'],
        ['FIN-100', 'Principles of Finance', 'Finance', 'UG'],
        ['FIN-534', 'Financial Management', 'Finance', 'GR'],
        ['MKT-100', 'Principles of Marketing', 'Marketing', 'UG'],
        ['MKT-500', 'Marketing Management', 'Marketing', 'GR'],
        ['HRM-500', 'Human Resource Management Foundations', 'Human Resources', 'GR'],
        ['HRM-510', 'Business Employment Law', 'Human Resources', 'GR'],
        ['HRM-530', 'Strategic Human Resource Management', 'Human Resources', 'GR'],
        ['CIS-105', 'Introduction to Information Technology', 'Information Systems', 'UG'],
        ['CIS-111', 'Introduction to Relational Database Management Systems', 'Information Systems', 'UG'],
        ['CIS-359', 'Disaster Recovery Management', 'Information Systems', 'UG'],
        ['CIS-500', 'Information Systems for Decision Making', 'Information Systems', 'GR'],
        ['CIS-505', 'Communication Technologies', 'Information Systems', 'GR'],
        ['CIS-524', 'Computer Interaction and Design', 'Information Systems', 'GR'],
        ['CRJ-100', 'Introduction to Criminal Justice', 'Criminal Justice', 'UG'],
        ['CRJ-105', 'Crime and Criminal Behavior', 'Criminal Justice', 'UG'],
        ['CRJ-220', 'Ethics and Leadership in Criminal Justice', 'Criminal Justice', 'UG'],
        ['SOC-100', 'Introduction to Sociology', 'Sociology', 'UG'],
        ['PSY-105', 'Introduction to Psychology', 'Psychology', 'UG'],
        ['HSA-500', 'Health Services Organization Management', 'Health Administration', 'GR'],
        ['HSA-515', 'Health Care Policy, Law and Ethics', 'Health Administration', 'GR']
      ]
    },

    liberty: {
      name: 'Liberty University',
      url: 'https://www.liberty.edu/online/courses/',
      note: 'Liberty publishes over 3,000 online courses across roughly 50 departments. A representative selection appears below.',
      courses: [
        ['ENGL-101', 'Composition and Rhetoric', 'English', 'UG'],
        ['ENGL-102', 'Composition and Literature', 'English', 'UG'],
        ['ENGL-201', 'English Literature I', 'English', 'UG'],
        ['BIBL-104', 'Survey of Biblical Literature', 'Biblical Studies', 'UG'],
        ['BIBL-105', 'Old Testament Survey', 'Biblical Studies', 'UG'],
        ['BIBL-110', 'Biblical Worldview', 'Biblical Studies', 'UG'],
        ['THEO-104', 'Introduction to Christian Thought', 'Theology', 'UG'],
        ['THEO-201', 'Systematic Theology I', 'Theology', 'UG'],
        ['CSTU-101', 'Western Culture', 'Cultural Studies', 'UG'],
        ['EVAN-101', 'Evangelism and Christian Life', 'Christian Ministry', 'UG'],
        ['MATH-114', 'Quantitative Reasoning', 'Mathematics', 'UG'],
        ['MATH-201', 'Introduction to Probability and Statistics', 'Mathematics', 'UG'],
        ['ACCT-211', 'Financial Principles of Accounting', 'Accounting', 'UG'],
        ['ACCT-212', 'Principles of Managerial Accounting', 'Accounting', 'UG'],
        ['ACCT-301', 'Intermediate Accounting I', 'Accounting', 'UG'],
        ['ACCT-401', 'Auditing', 'Accounting', 'UG'],
        ['BUSI-201', 'Introduction to Business Information Systems', 'Business', 'UG'],
        ['BUSI-240', 'Principles of Organizational Behavior', 'Business', 'UG'],
        ['BUSI-301', 'Business Law', 'Business', 'UG'],
        ['BUSI-310', 'Principles of Management', 'Business', 'UG'],
        ['BUSI-330', 'Principles of Marketing', 'Business', 'UG'],
        ['BUSI-320', 'Corporate Finance', 'Business', 'UG'],
        ['BUSI-411', 'Operations Management', 'Business', 'UG'],
        ['BUSI-600', 'Business Research Methods', 'Business (MBA)', 'GR'],
        ['BUSI-690', 'Strategic Management', 'Business (MBA)', 'GR'],
        ['PSYC-101', 'General Psychology', 'Psychology', 'UG'],
        ['PSYC-210', 'Developmental Psychology', 'Psychology', 'UG'],
        ['PSYC-255', 'Introduction to Research', 'Psychology', 'UG'],
        ['PSYC-341', 'Cognitive Psychology', 'Psychology', 'UG'],
        ['PSYC-510', 'Research Methods', 'Psychology', 'GR'],
        ['COUC-501', 'Counselor Professional Identity, Function and Ethics', 'Counseling', 'GR'],
        ['COUC-505', 'Counseling Techniques and the Helping Relationship', 'Counseling', 'GR'],
        ['NURS-301', 'Professional Transitions', 'Nursing', 'UG'],
        ['NURS-350', 'Nursing Research', 'Nursing', 'UG'],
        ['NURS-420', 'Community Health Nursing', 'Nursing', 'UG'],
        ['NURS-502', 'Theoretical Foundations of Nursing', 'Nursing (MSN)', 'GR'],
        ['CJUS-230', 'Criminal Law', 'Criminal Justice', 'UG'],
        ['CJUS-330', 'Criminology', 'Criminal Justice', 'UG'],
        ['EDUC-500', 'Learning Theory and Research', 'Education', 'GR'],
        ['EDUC-518', 'Curriculum and Methods', 'Education', 'GR'],
        ['HIUS-221', 'Survey of American History I', 'History', 'UG'],
        ['GOVT-200', 'Constitutional Government and Free Enterprise', 'Government', 'UG']
      ]
    },

    phoenix: {
      name: 'University of Phoenix',
      url: 'https://www.phoenix.edu/online-courses.html',
      note: 'Phoenix runs 5- and 6-week online courses. The /V suffix marks certain online sections.',
      courses: [
        ['ENG-110', 'Effective Essay Writing', 'English', 'UG'],
        ['ENG-200', 'Rhetoric and Research', 'English', 'UG'],
        ['COM-100', 'Introduction to Communication', 'Communications', 'UG'],
        ['COM-295', 'Business Communications', 'Communications', 'UG'],
        ['MTH-215', 'Quantitative Reasoning I', 'Mathematics', 'UG'],
        ['MTH-216', 'Quantitative Reasoning II', 'Mathematics', 'UG'],
        ['QNT-351', 'Quantitative Analysis for Business', 'Business Analytics', 'UG'],
        ['ACC-290', 'Principles of Accounting I', 'Accounting', 'UG'],
        ['ACC-291', 'Principles of Accounting II', 'Accounting', 'UG'],
        ['ACC-561', 'Accounting', 'Accounting', 'GR'],
        ['BUS-475', 'Integrated Business Topics', 'Business', 'UG'],
        ['MGT-311', 'Organizational Development', 'Management', 'UG'],
        ['MGT-521', 'Management', 'Management', 'GR'],
        ['LDR-531', 'Organizational Leadership', 'Management', 'GR'],
        ['HRM-300', 'Fundamentals of Human Resource Management', 'Human Resources', 'UG'],
        ['HRM-531', 'Human Capital Management', 'Human Resources', 'GR'],
        ['MKT-421', 'Marketing', 'Marketing', 'UG'],
        ['FIN-370', 'Finance for Business', 'Finance', 'UG'],
        ['FIN-571', 'Corporate Finance', 'Finance', 'GR'],
        ['ECO-365', 'Principles of Microeconomics', 'Economics', 'UG'],
        ['ECO-372', 'Principles of Macroeconomics', 'Economics', 'UG'],
        ['PSY-201', 'Foundations of Psychology', 'Psychology', 'UG'],
        ['PSY-315', 'Statistical Reasoning in Psychology', 'Psychology', 'UG'],
        ['SOC-100', 'Introduction to Sociology', 'Sociology', 'UG'],
        ['HCS-320', 'Health Care Communication Strategies', 'Health Care', 'UG'],
        ['HCS-341', 'Human Resources in Health Care', 'Health Care', 'UG'],
        ['NUR-403', 'Theories and Models of Nursing Practice', 'Nursing', 'UG'],
        ['NUR-587', 'Leadership and Management in Nursing', 'Nursing', 'GR'],
        ['CIS-207', 'Information Systems Fundamentals', 'Information Systems', 'UG'],
        ['CMGT-410', 'Project Planning and Implementation', 'Information Systems', 'UG'],
        ['CMGT-554', 'IT Infrastructure', 'Information Systems', 'GR'],
        ['CJS-201', 'Introduction to Criminal Justice', 'Criminal Justice', 'UG'],
        ['CJS-231', 'Criminology', 'Criminal Justice', 'UG']
      ]
    },

    devry: {
      name: 'DeVry University',
      url: 'https://www.devry.edu/online-programs.html',
      note: 'DeVry runs 8-week online sessions. Keller Graduate School courses share the same prefixes at 500+ level.',
      courses: [
        ['ENGL-112', 'Composition', 'English', 'UG'],
        ['ENGL-135', 'Advanced Composition', 'English', 'UG'],
        ['ENGL-216', 'Technical Writing', 'English', 'UG'],
        ['MATH-114', 'Algebra for College Students', 'Mathematics', 'UG'],
        ['MATH-221', 'Statistics for Decision Making', 'Mathematics', 'UG'],
        ['ACCT-212', 'Financial Accounting', 'Accounting', 'UG'],
        ['ACCT-346', 'Managerial Accounting', 'Accounting', 'UG'],
        ['ACCT-505', 'Managerial Accounting', 'Accounting', 'GR'],
        ['BUSN-115', 'Introduction to Business and Technology', 'Business', 'UG'],
        ['BUSN-278', 'Budgeting and Forecasting', 'Business', 'UG'],
        ['BUSN-379', 'Finance', 'Business', 'UG'],
        ['BUSN-412', 'Business Policy', 'Business', 'UG'],
        ['MGMT-303', 'Principles of Management', 'Management', 'UG'],
        ['MGMT-410', 'Human Resource Management', 'Management', 'UG'],
        ['MGMT-591', 'Leadership and Organizational Behavior', 'Management', 'GR'],
        ['MKTG-522', 'Marketing Management', 'Marketing', 'GR'],
        ['HRM-587', 'Managing Organizational Change', 'Human Resources', 'GR'],
        ['MIS-535', 'Managerial Applications of Information Technology', 'Information Systems', 'GR'],
        ['MIS-561', 'Database Applications and Data Mining', 'Information Systems', 'GR'],
        ['MIS-589', 'Networking Concepts and Applications', 'Information Systems', 'GR'],
        ['CIS-115', 'Logic and Design', 'Information Systems', 'UG'],
        ['CIS-170C', 'Programming with Lab', 'Information Systems', 'UG'],
        ['SEC-280', 'Principles of Information Systems Security', 'Cybersecurity', 'UG'],
        ['SEC-572', 'Network Security', 'Cybersecurity', 'GR'],
        ['NETW-202', 'Introduction to Networking with Lab', 'Networking', 'UG'],
        ['NETW-360', 'Wireless Technologies and Services', 'Networking', 'UG'],
        ['ECON-312', 'Principles of Economics', 'Economics', 'UG'],
        ['SOCS-185', 'Culture and Society', 'Social Sciences', 'UG'],
        ['PSYC-110', 'Psychology', 'Psychology', 'UG'],
        ['HUMN-303', 'Introduction to Humanities', 'Humanities', 'UG'],
        ['LAWS-310', 'Legal Environment', 'Legal Studies', 'UG'],
        ['HSM-330', 'Health Services Information Systems', 'Health Services', 'UG']
      ]
    },

    'purdue-global': {
      name: 'Purdue University Global',
      url: 'https://catalog.purdueglobal.edu/',
      note: 'Purdue Global runs 10-week terms. Course numbering: 100\u2013300 undergraduate, 500+ graduate.',
      courses: [
        ['CM-107', 'College Composition I', 'Composition', 'UG'],
        ['CM-220', 'College Composition II', 'Composition', 'UG'],
        ['MM-212', 'College Algebra', 'Mathematics', 'UG'],
        ['MM-255', 'Business Math and Statistical Measures', 'Mathematics', 'UG'],
        ['MM-305', 'Business Statistics', 'Mathematics', 'UG'],
        ['AC-114', 'Accounting I', 'Accounting', 'UG'],
        ['AC-116', 'Accounting II', 'Accounting', 'UG'],
        ['AC-410', 'Auditing', 'Accounting', 'UG'],
        ['MT-140', 'Introduction to Management', 'Management', 'UG'],
        ['MT-217', 'Finance', 'Management', 'UG'],
        ['MT-219', 'Marketing', 'Management', 'UG'],
        ['MT-450', 'Marketing Management', 'Management', 'UG'],
        ['MT-499', 'Bachelor\u2019s Capstone in Management', 'Management', 'UG'],
        ['MBA-600', 'Global Business Environment', 'Business (MBA)', 'GR'],
        ['HA-499', 'Bachelor\u2019s Capstone in Health Care Administration', 'Health Administration', 'UG'],
        ['HS-200', 'Diseases of the Human Body', 'Health Sciences', 'UG'],
        ['HS-410', 'Health Care Administration', 'Health Sciences', 'UG'],
        ['MN-501', 'Foundational Concepts of Advanced Nursing', 'Nursing (MSN)', 'GR'],
        ['MN-502', 'Theoretical Foundations of Advanced Nursing', 'Nursing (MSN)', 'GR'],
        ['MN-506', 'Advanced Pharmacology', 'Nursing (MSN)', 'GR'],
        ['MN-507', 'Advanced Pathophysiology', 'Nursing (MSN)', 'GR'],
        ['MN-552', 'Advanced Health Assessment', 'Nursing (MSN)', 'GR'],
        ['PS-124', 'Introduction to Psychology', 'Psychology', 'UG'],
        ['PS-220', 'Child and Adolescent Psychology', 'Psychology', 'UG'],
        ['PS-499', 'Bachelor\u2019s Capstone in Psychology', 'Psychology', 'UG'],
        ['CJ-100', 'Preparing for a Career in Public Safety', 'Criminal Justice', 'UG'],
        ['CJ-101', 'Introduction to the Criminal Justice System', 'Criminal Justice', 'UG'],
        ['CJ-227', 'Criminal Procedure', 'Criminal Justice', 'UG'],
        ['IT-190', 'Information Technology Concepts', 'Information Technology', 'UG'],
        ['IT-286', 'Networking Concepts', 'Information Technology', 'UG'],
        ['LS-311', 'Business Law', 'Legal Studies', 'UG']
      ]
    },

    rasmussen: {
      name: 'Rasmussen University',
      url: 'https://www.rasmussen.edu/degrees/',
      note: 'Rasmussen runs competency-based and course-based online terms across nursing, business and health sciences.',
      courses: [
        ['ENC-1101', 'English Composition', 'English', 'UG'],
        ['ENC-1102', 'English Composition II', 'English', 'UG'],
        ['COM-1002', 'Communicating in the 21st Century', 'Communications', 'UG'],
        ['MAT-1143', 'Quantitative Reasoning', 'Mathematics', 'UG'],
        ['MAT-2058', 'Statistics', 'Mathematics', 'UG'],
        ['NUR-2571', 'Professional Nursing III', 'Nursing', 'UG'],
        ['NUR-2755', 'Multidimensional Care IV', 'Nursing', 'UG'],
        ['NUR-2790', 'Professional Nursing IV', 'Nursing', 'UG'],
        ['NUR-3010', 'Professional Nursing Concepts', 'Nursing (RN-BSN)', 'UG'],
        ['NUR-3069', 'Health Assessment', 'Nursing (RN-BSN)', 'UG'],
        ['NUR-3846', 'Pharmacology', 'Nursing (RN-BSN)', 'UG'],
        ['NUR-4636', 'Community Health Nursing', 'Nursing (RN-BSN)', 'UG'],
        ['NUR-4827', 'Nursing Leadership and Management', 'Nursing (RN-BSN)', 'UG'],
        ['BSC-1085', 'Anatomy and Physiology I', 'Biological Sciences', 'UG'],
        ['BSC-1086', 'Anatomy and Physiology II', 'Biological Sciences', 'UG'],
        ['MCB-2010', 'Microbiology', 'Biological Sciences', 'UG'],
        ['HSC-1531', 'Medical Terminology', 'Health Sciences', 'UG'],
        ['HIM-1000', 'Introduction to Health Information Management', 'Health Information', 'UG'],
        ['B-490', 'Business Capstone', 'Business', 'UG'],
        ['ACG-2021', 'Financial Accounting', 'Accounting', 'UG'],
        ['PSY-1012', 'General Psychology', 'Psychology', 'UG'],
        ['DEP-2004', 'Human Growth and Development', 'Psychology', 'UG'],
        ['CCJ-1020', 'Introduction to Criminal Justice', 'Criminal Justice', 'UG']
      ]
    },

    uagc: {
      name: 'University of Arizona Global Campus',
      url: 'https://catalog.uagc.edu/',
      note: 'Formerly Ashford University. Runs 5- and 6-week online courses.',
      courses: [
        ['ENG-121', 'English Composition I', 'English', 'UG'],
        ['ENG-122', 'English Composition II', 'English', 'UG'],
        ['ENG-225', 'Introduction to Film', 'English', 'UG'],
        ['GEN-499', 'General Education Capstone', 'General Education', 'UG'],
        ['MAT-222', 'Intermediate Algebra', 'Mathematics', 'UG'],
        ['BUS-101', 'Introduction to Business', 'Business', 'UG'],
        ['BUS-303', 'Human Resources Management', 'Business', 'UG'],
        ['BUS-308', 'Statistics for Managers', 'Business', 'UG'],
        ['BUS-311', 'Business Law I', 'Business', 'UG'],
        ['BUS-330', 'Principles of Marketing', 'Business', 'UG'],
        ['BUS-340', 'Business Communications', 'Business', 'UG'],
        ['BUS-401', 'Principles of Finance', 'Business', 'UG'],
        ['BUS-475', 'Business and Society', 'Business', 'UG'],
        ['ACC-205', 'Principles of Accounting I', 'Accounting', 'UG'],
        ['ACC-206', 'Principles of Accounting II', 'Accounting', 'UG'],
        ['PSY-101', 'Introduction to Psychology', 'Psychology', 'UG'],
        ['PSY-202', 'Adult Development and Life Assessment', 'Psychology', 'UG'],
        ['PSY-304', 'Lifespan Development', 'Psychology', 'UG'],
        ['SOC-120', 'Introduction to Ethics and Social Responsibility', 'Sociology', 'UG'],
        ['SOC-313', 'Social Implications of Medical Issues', 'Sociology', 'UG'],
        ['HCA-322', 'Health Care Ethics and Medical Law', 'Health Care Administration', 'UG'],
        ['HCA-375', 'Continuous Quality Monitoring and Accreditation', 'Health Care Administration', 'UG'],
        ['ECE-101', 'Introduction to Early Childhood Education', 'Early Childhood Education', 'UG'],
        ['EDU-372', 'Educational Psychology', 'Education', 'UG'],
        ['CRJ-201', 'Introduction to Criminal Justice', 'Criminal Justice', 'UG'],
        ['INF-103', 'Computer Literacy', 'Information Technology', 'UG'],
        ['POL-201', 'American National Government', 'Political Science', 'UG'],
        ['HIS-103', 'World Civilizations I', 'History', 'UG']
      ]
    },

    'american-public': {
      name: 'American Public University / AMU',
      url: 'https://www.apu.apus.edu/academics/',
      note: 'APU and AMU share a course catalogue and 8- and 16-week online sessions.',
      courses: [
        ['ENGL-101', 'Proficiency in Writing', 'English', 'UG'],
        ['ENGL-110', 'Making Writing Relevant', 'English', 'UG'],
        ['MATH-110', 'College Algebra', 'Mathematics', 'UG'],
        ['MATH-302', 'Statistics', 'Mathematics', 'UG'],
        ['BUSN-311', 'Business Law', 'Business', 'UG'],
        ['BUSN-623', 'Organizational Behavior', 'Business', 'GR'],
        ['ACCT-105', 'Accounting I', 'Accounting', 'UG'],
        ['ACCT-300', 'Intermediate Accounting I', 'Accounting', 'UG'],
        ['MGMT-314', 'Management Information Systems', 'Management', 'UG'],
        ['MGMT-600', 'Managerial Analysis', 'Management', 'GR'],
        ['MKTG-301', 'Principles of Marketing', 'Marketing', 'UG'],
        ['CMRJ-100', 'Introduction to Criminal Justice', 'Criminal Justice', 'UG'],
        ['CMRJ-306', 'Criminal Investigation', 'Criminal Justice', 'UG'],
        ['HLSS-302', 'Homeland Security and Defense', 'Homeland Security', 'UG'],
        ['HLSS-320', 'Terrorism', 'Homeland Security', 'UG'],
        ['NURS-320', 'Health Assessment', 'Nursing', 'UG'],
        ['NURS-330', 'Pathophysiology', 'Nursing', 'UG'],
        ['PSYC-101', 'Introduction to Psychology', 'Psychology', 'UG'],
        ['PSYC-221', 'Social Psychology', 'Psychology', 'UG'],
        ['SOCI-111', 'Introduction to Sociology', 'Sociology', 'UG'],
        ['HIST-101', 'American History to 1877', 'History', 'UG'],
        ['ISSC-341', 'Introduction to Networking', 'Information Systems', 'UG'],
        ['ISSC-421', 'Computer Forensics', 'Information Systems', 'UG']
      ]
    },

    excelsior: {
      name: 'Excelsior University',
      url: 'https://www.excelsior.edu/programs/',
      note: 'Excelsior is credit-transfer focused, with 8-week online terms and strong nursing and technology catalogues.',
      courses: [
        ['ENG-101', 'English Composition', 'English', 'UG'],
        ['ENG-102', 'English Composition II', 'English', 'UG'],
        ['MAT-121', 'College Algebra', 'Mathematics', 'UG'],
        ['MAT-230', 'Statistics', 'Mathematics', 'UG'],
        ['NUR-330', 'Health Assessment', 'Nursing', 'UG'],
        ['NUR-350', 'Nursing Research', 'Nursing', 'UG'],
        ['NUR-360', 'Community Health Nursing', 'Nursing', 'UG'],
        ['NUR-420', 'Nursing Leadership and Management', 'Nursing', 'UG'],
        ['NUR-499', 'Nursing Capstone', 'Nursing', 'UG'],
        ['HSC-320', 'Pathophysiology', 'Health Sciences', 'UG'],
        ['BUS-301', 'Principles of Management', 'Business', 'UG'],
        ['BUS-320', 'Business Law', 'Business', 'UG'],
        ['ACC-201', 'Financial Accounting', 'Accounting', 'UG'],
        ['PSY-101', 'General Psychology', 'Psychology', 'UG'],
        ['CJ-101', 'Introduction to Criminal Justice', 'Criminal Justice', 'UG'],
        ['IT-210', 'Introduction to Information Technology', 'Information Technology', 'UG'],
        ['CYS-301', 'Cybersecurity Fundamentals', 'Cybersecurity', 'UG']
      ]
    },

    champlain: {
      name: 'Champlain College Online',
      url: 'https://online.champlain.edu/degrees-certificates',
      note: 'Champlain Online runs 7-week terms with strong cybersecurity, business and healthcare administration catalogues.',
      courses: [
        ['ENGL-101', 'Writing and Rhetoric', 'English', 'UG'],
        ['MATH-180', 'Statistics', 'Mathematics', 'UG'],
        ['ACCT-130', 'Financial Accounting', 'Accounting', 'UG'],
        ['ACCT-230', 'Managerial Accounting', 'Accounting', 'UG'],
        ['BUS-125', 'Introduction to Business', 'Business', 'UG'],
        ['BUS-230', 'Principles of Management', 'Business', 'UG'],
        ['BUS-330', 'Organizational Behavior', 'Business', 'UG'],
        ['MGMT-320', 'Human Resource Management', 'Management', 'UG'],
        ['MKT-230', 'Principles of Marketing', 'Marketing', 'UG'],
        ['CMIT-135', 'Introduction to Networking', 'Information Technology', 'UG'],
        ['CSEC-140', 'Introduction to Cybersecurity', 'Cybersecurity', 'UG'],
        ['CSEC-240', 'Network Security', 'Cybersecurity', 'UG'],
        ['CSEC-310', 'Digital Forensics', 'Cybersecurity', 'UG'],
        ['HCA-200', 'Introduction to Healthcare Administration', 'Healthcare Administration', 'UG'],
        ['HCA-310', 'Healthcare Law and Ethics', 'Healthcare Administration', 'UG'],
        ['PSY-105', 'Introduction to Psychology', 'Psychology', 'UG'],
        ['SOC-110', 'Introduction to Sociology', 'Sociology', 'UG']
      ]
    },

    regent: {
      name: 'Regent University',
      url: 'https://www.regent.edu/programs/',
      note: 'Regent runs 8-week online sessions with a Christian-worldview core across all programmes.',
      courses: [
        ['ENGL-101', 'English Composition I', 'English', 'UG'],
        ['ENGL-102', 'English Composition II', 'English', 'UG'],
        ['UNIV-101', 'Foundations of University Studies', 'General Education', 'UG'],
        ['MATH-101', 'College Algebra', 'Mathematics', 'UG'],
        ['MATH-201', 'Statistics', 'Mathematics', 'UG'],
        ['BIBL-110', 'Old Testament Survey', 'Biblical Studies', 'UG'],
        ['BIBL-120', 'New Testament Survey', 'Biblical Studies', 'UG'],
        ['THEO-201', 'Christian Theology', 'Theology', 'UG'],
        ['BUSN-100', 'Introduction to Business', 'Business', 'UG'],
        ['BUSN-320', 'Principles of Management', 'Business', 'UG'],
        ['ACCT-201', 'Financial Accounting', 'Accounting', 'UG'],
        ['PSYC-101', 'Introduction to Psychology', 'Psychology', 'UG'],
        ['PSYC-310', 'Abnormal Psychology', 'Psychology', 'UG'],
        ['COUN-500', 'Introduction to Counseling', 'Counseling', 'GR'],
        ['CJ-101', 'Introduction to Criminal Justice', 'Criminal Justice', 'UG'],
        ['LAW-501', 'Legal Foundations', 'Law', 'GR'],
        ['EDUC-500', 'Foundations of Education', 'Education', 'GR']
      ]
    },

    asu: {
      name: 'Arizona State University Online',
      url: 'https://asuonline.asu.edu/online-degree-programs/',
      note: 'ASU Online runs 7.5-week sessions. Course numbering follows the main campus catalogue.',
      courses: [
        ['ENG-101', 'First-Year Composition', 'English', 'UG'],
        ['ENG-102', 'First-Year Composition', 'English', 'UG'],
        ['MAT-142', 'College Mathematics', 'Mathematics', 'UG'],
        ['MAT-210', 'Brief Calculus', 'Mathematics', 'UG'],
        ['STP-226', 'Elements of Statistics', 'Statistics', 'UG'],
        ['ACC-231', 'Uses of Accounting Information I', 'Accounting', 'UG'],
        ['ACC-241', 'Uses of Accounting Information II', 'Accounting', 'UG'],
        ['MGT-300', 'Principles of Management and Leadership', 'Management', 'UG'],
        ['MKT-300', 'Principles of Marketing', 'Marketing', 'UG'],
        ['FIN-300', 'Fundamentals of Finance', 'Finance', 'UG'],
        ['ECN-211', 'Macroeconomic Principles', 'Economics', 'UG'],
        ['ECN-212', 'Microeconomic Principles', 'Economics', 'UG'],
        ['PSY-101', 'Introduction to Psychology', 'Psychology', 'UG'],
        ['PSY-230', 'Introduction to Statistics', 'Psychology', 'UG'],
        ['SOC-101', 'Introductory Sociology', 'Sociology', 'UG'],
        ['BIO-181', 'General Biology I', 'Biology', 'UG'],
        ['BIO-201', 'Human Anatomy and Physiology I', 'Biology', 'UG'],
        ['CHM-101', 'Introductory Chemistry', 'Chemistry', 'UG'],
        ['CSE-110', 'Principles of Programming', 'Computer Science', 'UG'],
        ['CSE-205', 'Object-Oriented Programming and Data Structures', 'Computer Science', 'UG'],
        ['NUR-300', 'Professional Nursing Practice', 'Nursing', 'UG'],
        ['NUR-345', 'Evidence-Based Practice', 'Nursing', 'UG']
      ]
    },

    cornell: {
      name: 'Cornell University (eCornell)',
      url: 'https://ecornell.cornell.edu/',
      note: 'eCornell delivers certificate courses rather than a full degree catalogue. Codes follow the certificate programme, not the main campus catalogue.',
      courses: [
        ['HAME-500', 'Financial Accounting Principles', 'Hotel Administration', 'GR'],
        ['HAME-511', 'Mastering the Time Value of Money', 'Hotel Administration', 'GR'],
        ['ILRMD-501', 'Leadership Fundamentals', 'Industrial and Labor Relations', 'GR'],
        ['ILRHR-520', 'Human Resources Management', 'Industrial and Labor Relations', 'GR'],
        ['CIPA-500', 'Public Policy Analysis', 'Public Affairs', 'GR'],
        ['NBAY-500', 'Digital Marketing Foundations', 'Business', 'GR'],
        ['SHA-500', 'Hospitality Marketing', 'Hospitality', 'GR']
      ]
    }
  };

  /* Aliases so a page handle variant resolves to the same catalogue. */
  var C = window.TMOC_CATALOG;
  C['southern-new-hampshire'] = C.snhu;
  C['uop'] = C.phoenix;
  C['arizona-state'] = C.asu;
  C['grand-canyon'] = C.gcu;
})();
